import { Grid, Paper } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { irem } from '../../utils'

export type ProductCardWrapperProps = React.ComponentProps<typeof Paper> & {
  //
}

export const ProductCardPaper = styled(Paper)`
  min-width: ${irem(300)};
  max-width: calc(100vw - ${irem(50)});
  width: 100%;
  padding: ${irem(35)} ${irem(18)} ${irem(18)};
  margin-right: ${irem(25)};
  border-radius: ${irem(12)};

  ${props => props.theme.breakpoints.up('sm')} {
    width: ${props => props.theme.typography.pxToRem(467)};
    margin-right: ${props => props.theme.typography.pxToRem(40)};
    padding: ${irem(40)} ${irem(30)} ${irem(50)};
  }
`

export const ProductCardWrapper: React.FC<PropsWithChildren<ProductCardWrapperProps>> = ({ children, ...props }) => {
  return (
    <ProductCardPaper {...props} data-product-card elevation={0}>
      <Grid container wrap={'nowrap'} direction={'column'} alignItems={'stretch'} justifyContent={'flex-start'} style={{ height: '100%' }}>
        { children }
      </Grid>
    </ProductCardPaper>
  )
}
